import { render, staticRenderFns } from "./add-royalty-free-popup.vue?vue&type=template&id=2131b3a2"
import script from "./add-royalty-free-popup.vue?vue&type=script&lang=js"
export * from "./add-royalty-free-popup.vue?vue&type=script&lang=js"
import style0 from "./add-royalty-free-popup.vue?vue&type=style&index=0&id=2131b3a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports